import React, { useState, useCallback } from 'react';
import Box from '@mui/material/Box';
import FeedbackActions from './FeedbackActions';
import FeedbackForm from './FeedbackForm';
import CopyButton from './CopyButton';

export default function ActionsContainer({
  message,
  feedback,
  onFeedbackSubmit,
  onFeedbackDelete,
  sessionId,
  eventId
}) {
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [feedbackFormHandlers, setFeedbackFormHandlers] = useState(null);

  const handleFormStateChange = useCallback((show, handlers) => {
    setShowFeedbackForm(show);
    if (handlers) {
      setFeedbackFormHandlers(handlers);
    }
  }, []);

  return (
    <Box
      sx={{
        mt: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          flexWrap: 'nowrap',
          opacity: 0.7,
          transition: 'opacity 0.2s',
          '&:hover': {
            opacity: 1
          }
        }}
      >
        <FeedbackActions
          feedback={feedback}
          onFeedbackSubmit={onFeedbackSubmit}
          onFeedbackDelete={onFeedbackDelete}
          sessionId={sessionId}
          eventId={eventId}
          onFormStateChange={handleFormStateChange}
        />
        <CopyButton message={message} />
      </Box>
      {showFeedbackForm && feedbackFormHandlers && (
        <Box 
          sx={{ 
            width: '100%', 
            maxWidth: '100%',
            mt: 0.5,
            alignSelf: 'stretch',
            boxSizing: 'border-box'
          }}
        >
          <FeedbackForm
            onSubmit={feedbackFormHandlers.handleFeedbackSubmit}
            onCancel={feedbackFormHandlers.handleFeedbackCancel}
            initialReason={feedback?.reason || ''}
          />
        </Box>
      )}
    </Box>
  );
}
